import React from "react";
import { restoresRef } from "../firebase";
import { useDeltaSyncedCollection } from "../customHooks/useDeltaSyncedCollection";

const RestoresContext = React.createContext(null);

// All restores (binned primaries) created by the user's associated accounts - kept in sync with
// Firestore through this device's cache plus a listener on recently modified documents, so every
// restore is available to list and search, not just recent ones. See useDeltaSyncedCollection.
const RestoresProvider = (props) => {
  const { docs, loading } = useDeltaSyncedCollection(restoresRef);

  return (
    <RestoresContext.Provider value={{ timesheets: docs, loading }}>
      {props.children}
    </RestoresContext.Provider>
  );
};

export { RestoresProvider, RestoresContext };
